export default __webpack_public_path__ + "static/media/021-chair.63a82c99.svg";